module.exports = __webpack_public_path__ + "static/media/contact-admin.089268bd.png";